import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { map, catchError } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { HttpClient, HttpResponse, HttpErrorResponse } from '@angular/common/http';
import { LiveSession } from 'app/_models/live-session.model';
import { ClientProcessingError } from 'app/_errors/client-processing.error';
import { UnknownApplicationError } from 'app/_errors/unknown-application.error';
import { throwError } from 'rxjs';

@Injectable()
export class LiveSessionService {

  constructor(private http: HttpClient) { }

  public getAllLiveSessionsNoPagination(sort = ['startTime,desc']): Observable<any> {
    let paginationString = '';
    paginationString += '?size=10000';
    paginationString += '&page=0';
    const sortString = '&sort=' + sort;

    return this.http.get(environment.apiUrl + 'api/ext-user-session/open-with-health-checks' + paginationString + sortString)
      .pipe(map(this.handleData))
      .pipe(catchError(this.handleError));
  }

  public getAllLiveSessionsNoPaginationMapped(): Observable<LiveSession[]> {
    return this.getAllLiveSessionsNoPagination()
      .pipe(map(response => response.map(liveSessionData => new LiveSession().deserialize(liveSessionData))));
  }

  // Handle Responses
  private handleData(res: HttpResponse<any>) {
    const body = res;
    return body;
  }

  public handleDataWithHeaders(res: HttpResponse<any>) {
    const headers = res.headers;
    const body = res.body;
    const data = {
      'headers': headers,
      'body': body
    };
    return data;
  }

  private handleError(error: any) {
    if (error instanceof HttpErrorResponse) {
      return throwError(error);
    }

    if (error instanceof Error) {
      return throwError(
        new ClientProcessingError('The application could not process the server response.', error)
      );
    }

    return throwError(
      new UnknownApplicationError('The application threw an unknown error value.', error)
    );
  }
}
